// @flow
import * as React from 'react';
import { StyledToggle } from '../../../../../styled-toggle';
import { Menu } from '@mui/material';
import { ArAgentConfirmationToggleRunningLateOption } from './ar-agent-confirmation-toggle-running-late-option';
import { ArAgentConfirmationToggleReBookOption } from './ar-agent-confirmation-toggle-re-book-option';
import { ArAgentConfirmationToggleReAssignOption } from './ar-agent-confirmation-toggle-re-assign-option';
import { useAppointmentReminderRequiredAgentConfirmationConfirmMutation } from '../../../../../../shared';

export const ArAgentConfirmationToggle = ({id}: {id: string}) => {
  const [request, {loading}] = useAppointmentReminderRequiredAgentConfirmationConfirmMutation({
    variables: {id}
  });
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, value: boolean) => {
    if (!value) {
      setAnchorEl(e.currentTarget);
    } else {
      request();
    }
  }

  return (<>
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      sx={{zIndex: 10000}}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <ArAgentConfirmationToggleRunningLateOption id={id} onClick={handleClose} />
      <ArAgentConfirmationToggleReBookOption id={id} onClick={handleClose} />
      <ArAgentConfirmationToggleReAssignOption id={id} onClick={handleClose} />
    </Menu>
    <StyledToggle onChange={handleClick} value={null} loading={loading} />
  </>
  );
};
